import { concatStyleSets, IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontWeights } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';
import { DetailsListSizes } from '../DetailsList/DetailsList.styles';
import { ListRowSizes } from '../ListRow/ListRow.styles';
export interface IBasicTableStyles {
  root: IStyle;
  columnHeader: IStyle;
  cell: IStyle;
  cellContents: IStyle;
  rows: IStyle;
  row: IStyle;
}
export const basicTableStylesDefault = (theme: IH2OTheme): Partial<IBasicTableStyles> => ({
  root: { border: `1px solid ${theme.palette?.gray200}`, overflow: 'auto' },
  columnHeader: {
    display: 'flex',
    height: ListRowSizes.Height,
    '.h2o-BasicTable-cell': {
      backgroundColor: theme.palette?.gray200,
      fontWeight: FontWeights.semiBold,
      fontSize: 13,
      borderLeft: '1px solid white',
      '&:first-child': { borderLeftColor: 'transparent' },
    },
    '.h2o-BasicTable-cell:first-child': {
      borderLeftColor: 'transparent',
    },
  },
  row: { display: 'flex' },
  cell: { ...CommonStyles.flexCenterVertically, paddingLeft: DetailsListSizes.CellLeftPadding, flexShrink: 0 },
  cellContents: {
    ...CommonStyles.truncateString,
  },
});

export const basicTableStylesWhiteBorder = (theme: IH2OTheme): Partial<IBasicTableStyles> =>
  concatStyleSets(basicTableStylesDefault(theme), {
    root: { borderColor: theme.palette?.white, backgroundColor: theme.palette?.white },
  });
